import { object, string } from 'yup';
import { TFunction } from 'i18next';

export function makeCodeSchema(t: TFunction) {
  return object().shape({
    code: string().required(t('form.required')),
  });
}
